import { Text, TextProps } from '@chakra-ui/react';

interface ReceiptTitleProps extends TextProps {
  children: string;
}

export default function ReceiptTitle({
  children,
  ...props
}: ReceiptTitleProps) {
  return (
    <Text
      fontSize=".875rem"
      lineHeight="128.571%"
      color="#656B76"
      whiteSpace="nowrap"
      {...props}
    >
      {children}
    </Text>
  );
}
